import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '../shared/toast/toast.service';
import { ErrorService } from './service/error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private readonly errorService: ErrorService,
    private readonly toastService: ToastService,
  ) {}

  public handleError(error: any): void {
    let message: string = undefined;

    if (this.isHttpErrorResponse(error)) {
      message = this.errorService.getServerErrorMessage(error);
    } else if (this.isHttpErrorResponse(error.rejection)) {
      message = this.errorService.getServerErrorMessage(error.rejection);
    }

    if (message) {
      this.toastService.show(message, 'danger');
    }

    console.error(error);
  }

  private isHttpErrorResponse(error: any): error is HttpErrorResponse {
    return error instanceof HttpErrorResponse;
  }
}
